import { render, staticRenderFns } from "./ProcessBucket.vue?vue&type=template&id=2955fd98&scoped=true&"
import script from "./ProcessBucket.vue?vue&type=script&lang=js&"
export * from "./ProcessBucket.vue?vue&type=script&lang=js&"
import style0 from "./ProcessBucket.vue?vue&type=style&index=0&id=2955fd98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955fd98",
  null
  
)

export default component.exports